import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Email({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M2.66667 4.66687C2.29848 4.66687 2 4.96535 2 5.33354V18.6669C2 19.0351 2.29848 19.3335 2.66667 19.3335H21.3333C21.7015 19.3335 22 19.0351 22 18.6669V5.33354C22 4.96535 21.7015 4.66687 21.3333 4.66687H2.66667ZM9.86505 11.5152L4.2888 6.0002H19.7112L14.1349 11.5152L12 13.4366L9.86505 11.5152ZM15.5407 12.0002L20.6667 6.93052V17.0699L16.5096 12.9585L15.5168 13.8519L19.7112 18.0002H4.2888L8.48315 13.8519L7.49041 12.9585L3.33333 17.0699V6.93052L8.45935 12.0002L8.44002 12.0193L11.6203 14.8816C11.8482 15.0397 12.1518 15.0397 12.3796 14.8816L15.56 12.0193L15.5407 12.0002Z"
        fill={iconColor}
      />
    </Svg>
  );
}
